import React, { useState, useEffect, useContext } from 'react';

import { Spinner } from "react-bootstrap";

function Loading() {
  return (
    <Spinner animation="border" role="status">
       <span className="visually-hidden"></span>
    </Spinner>
  )
}

export { Loading };